import React, { useCallback } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { cloneDeep, set } from 'lodash';
import { useTranslation } from 'react-i18next';
import { productCpmanualTypeList, customStylesForOCP, checkIsNumber } from '../../../Components/helper';
import { commonPath, customColumnPath } from '../fieldPath';
import RenderOptionsItem from './RenderOptionsItem';
import RenderLabelOptions from './RenderLabelOptions';

function ManualColumnSection({ modalState, setModalState, cardEle, cardIndex, handleChange }) {
  const moveOption = (dragIndex, hoverIndex, cardEle, parentIndex) => {
    const currList = swapArrayLocs(cardEle?.options, dragIndex, hoverIndex);
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options = currList;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const addNewOptions = (parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options.push({ name: '' });
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const handleOptionChange = (value, index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options[index].name = value;
    copyState[parentIndex].hasError = false;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const handleDefaultChange = (value, index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    const manualType = copyState[parentIndex]?.manualType?.key;
    if ((manualType === 'Dropdown' || manualType === 'Multi_select_Dropdown') && value) {
      copyState[parentIndex].options.forEach((opt, i) => {
        opt.isDefault = i === index;
      });
    } else {
      copyState[parentIndex].options[index].isDefault = value;
    }

    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  function swapArrayLocs(arr, index1, index2) {
    const temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
  }

  const removeOption = (index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options.splice(index, 1);
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const renderOptionsList = useCallback(
    (option, optionIndex, cardEle, cardIndex) => {
      return (
        <RenderOptionsItem
          column={option}
          index={optionIndex}
          parentIndex={cardIndex}
          moveCard={moveOption}
          id={`${cardEle?._id}_${option?.Nmae}_${optionIndex}_${cardIndex}`}
          remove={removeOption}
          addNew={addNewOptions}
          handleChange={handleOptionChange}
          handleDefaultChange={handleDefaultChange}
          cardEle={cardEle}
          wholeArry={cardEle?.options}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modalState?.cards],
  );

  const moveLabel = (dragIndex, hoverIndex, cardEle, parentIndex) => {
    const currList = swapArrayLocs(cardEle?.labelColoursOptions, dragIndex, hoverIndex);
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions = currList;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const addNewlabels = (parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions.push({
      colourHexCode: '',
      colourName: '',
    });
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const handleLabelChange = (value, index, parentIndex, key) => {
    const copyState = cloneDeep(modalState?.cards);
    set(copyState, customColumnPath(parentIndex, index, key).LABELCOLOURS_UPDATES, value);
    copyState[parentIndex].hasError = false;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const removelabel = (index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions.splice(index, 1);
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const renderlabelList = useCallback(
    (label, labelIndex, cardEle, cardIndex) => {
      return (
        <RenderLabelOptions // label Item changes
          column={label}
          index={labelIndex}
          parentIndex={cardIndex}
          moveCard={moveLabel}
          id={`${cardEle?._id}_${label?.Nmae}_${labelIndex}_${cardIndex}`}
          removeLabel={removelabel}
          addNewLabel={addNewlabels}
          handleChange={handleLabelChange}
          cardEle={cardEle}
          wholeArry={cardEle?.labelColoursOptions}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modalState?.cards],
  );
  const { t } = useTranslation('common');

  const changeStatusArray = (array, e, cardIndex, keyIn, keyName) => {
    handleChange(e.target.value, customColumnPath(cardIndex, keyIn, keyName).STATUS_COLOURS, cardIndex);
  };

  return (
    <>
      <Col lg={12} className="">
        <div className="common-react-select">
          <label className="asterisk-req field-name">
            {t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.MANUAL_TYPE')} <span>*</span>
          </label>
          <Select
            name="manualType"
            options={productCpmanualTypeList}
            getOptionLabel={(option) => `${option.type}`}
            getOptionValue={(option) => `${option.key}`}
            value={cardEle?.manualType}
            maxMenuHeight={140}
            menuPlacement="bottom"
            menuPosition="fixed"
            menuShouldBlockScroll
            menuShouldScrollIntoView
            styles={customStylesForOCP}
            isLoading={modalState.loading}
            classNamePrefix="common-select"
            onChange={(e) =>
              handleChange(e, commonPath(cardIndex, 'manualType').COMMON, cardIndex, [
                'location',
                'subLocation',
                'attribute',
                'output',
                'locationType',
                'locationPlacement',
                'colourCoading',
                'options',
                'labelColoursOptions',
                'statusColoursOptions',
                'status',
                'characterLimit',
                'customDurations',
                'dependentObj',
              ])
            }
            placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.SELECT_MANUAL_TYPE')}
          />
          {cardEle.hasError && !cardEle?.manualType && (
            <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.MANUAL_TYPE_REQUIRED')}</span>
          )}
        </div>
      </Col>
      {['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(cardEle?.manualType?.key) && (
        <DndProvider backend={HTML5Backend} key={`option_${cardEle?._id}_${cardEle?.name}_${cardIndex}`}>
          <Col lg={12} className="">
            <div className="common-react-select mb-0">
              <label className="asterisk-req field-name">
                {t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.MANUAL_TYPE_OPTIONS')} <span>*</span>
              </label>
              {cardEle?.options?.map((optionEle, optionIndex) => {
                return renderOptionsList(optionEle, optionIndex, cardEle, cardIndex);
              })}
            </div>
          </Col>
        </DndProvider>
      )}
      {cardEle?.manualType?.key === 'Label' && (
        <DndProvider backend={HTML5Backend} key={`label_${cardEle?._id}_${cardEle?.name}_${cardIndex}`}>
          <Col lg={12} className="mb-3">
            <label className="asterisk-req field-name">
              {t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.MANUAL_TYPE_LABELS')} <span>*</span>
            </label>
            {cardEle?.labelColoursOptions?.map((labelEle, labelIndex) => {
              return renderlabelList(labelEle, labelIndex, cardEle, cardIndex);
            })}
            {cardEle.hasError && cardEle?.labelColoursOptions?.filter((e) => e?.isLabelColourChecked).length === 0 && (
              <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.SELECT_AT_LEAST_ONE_LABEL')}</span>
            )}
          </Col>
        </DndProvider>
      )}
      {cardEle?.manualType?.key === 'Status' && (
        <Col lg={{ span: 6, offset: 3 }} className="mb-4">
          <FormGroup className="m-0">
            <div className="input-group form-floating-label fixed-label">
              <button
                className="btn p-0"
                value={cardEle?.isStatusEditTrue}
                onClick={() => handleChange(!cardEle?.isStatusEditTrue, commonPath(cardIndex, 'isStatusEditTrue').COMMON, cardIndex)}
              >
                <span className="icon-Edit-1 f-20 mr-2" />
                {t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.EDIT_COLOUR')}
              </button>
              {cardEle?.statusColoursOptions?.map((stat, keyIn) => {
                return (
                  <>
                    <div
                      className="status-color-option"
                      onClick={() => handleChange(stat, commonPath(cardIndex, 'status').COMMON, cardIndex)}
                      style={
                        cardEle?.status?.colourHexCode === stat?.colourHexCode
                          ? {
                              border: '2px solid #8d8dff',
                            }
                          : {}
                      }
                    >
                      <div className="color-content">
                        <input
                          type="color"
                          className="form-control"
                          value={stat?.colourHexCode}
                          onChange={(e) => changeStatusArray(cardEle?.statusColoursOptions, e, cardIndex, keyIn, 'colourHexCode')}
                          disabled={!cardEle?.isStatusEditTrue}
                        />
                      </div>
                      <input
                        type="text"
                        className="text-content f-14"
                        value={stat?.colourName}
                        placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.ADD_COLOUR_NAME')}
                        onChange={(e) => changeStatusArray(cardEle?.statusColoursOptions, e, cardIndex, keyIn, 'colourName')}
                        readOnly={!cardEle?.isStatusEditTrue}
                      />
                    </div>
                    <br />
                  </>
                );
              })}
            </div>
            {cardEle.hasError && !cardEle?.status && (
              <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.PLEASE_SELECT_STATUS')}</span>
            )}
          </FormGroup>
        </Col>
      )}
      {cardEle?.manualType?.key === 'Textbox' && (
        <Col lg="12" className="mb-4">
          <FormGroup className="m-0">
            <div className="common-input-control">
              <label className="asterisk-req field-name">{t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.CHARACTER_LIMIT')}</label>

              <input
                type="number"
                className="form-control f-16"
                value={cardEle?.characterLimit}
                placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.ADD_CHARACTER_UNIT')}
                min="1"
                step="1"
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '' || /^[1-9]\d*$/.test(val)) {
                    handleChange(val, commonPath(cardIndex, 'characterLimit').COMMON, cardIndex);
                  }
                }}
              />
            </div>
          </FormGroup>
          {cardEle.hasError && (!cardEle?.characterLimit || parseInt(cardEle?.characterLimit, 10) < 1) && (
            <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.MANUAL_COLUMN_SECTION.CHARACTER_LIMIT_REQUIRED')}</span>
          )}
        </Col>
      )}
    </>
  );
}

export default ManualColumnSection;
